//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Theme from '@/listing-app/mixins/Theme'
export default {
	name: "Header",
	mixins: [Theme],
  props: ["title", "sqft", "availability"]
}
